const AppURLs = {
  termsOfUse: 'https://fiveirongolf.com/mobile-terms-conditions/',
  privacyPolicy: 'https://fiveirongolf.com/privacy-policy/',
};

export default AppURLs;
